module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h1', [_vm._v("NKO"), _c('br'), _vm._v(" Social Matcher")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col-xs-8 col-xs-offset-2"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "href": "#/game"
    }
  }, [_vm._v("PLAY")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "href": "#/statistics"
    }
  }, [_vm._v("\n        STATISTICS\n      ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "href": "#/analytics"
    }
  }, [_vm._v("\n        ANALYTICS (not mobile)\n      ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fa6ffe0c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/index.vue
// module id = 58
// module chunks = 0